// Records first-run wizard/checklist completion. POST /api/surfaces/onboarding/complete
// upserts `first_run_completed_at` (idempotent — ON CONFLICT user_id). On success we
// invalidate the readiness query so the gate re-reads `firstRunCompleted` and releases to
// the dashboard.
//
// `apiFetch` throws `ApiError` on a non-2xx, so a failed write REJECTS — the caller
// (DoneStep / ReturnChecklist) surfaces it and lets the user retry, rather than silently
// "completing" onboarding that was never recorded.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';
import { onboardingReadinessQueryKey } from './useOnboardingReadiness';

export function useCompleteOnboarding() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiFetch<{ success: boolean }>('/api/surfaces/onboarding/complete', { method: 'POST' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: onboardingReadinessQueryKey }),
  });
}
